import type { FaireProductEntity } from "../../entity_types/product";

export const p_dgnkxz9tpz: FaireProductEntity = {
  token: "p_dgnkxz9tpz",
  type: "product",
  name: "Chunky Oblong Plaid Multi Color Brushed Scarf (18 colors)",
  brandToken: "b_jcn5s8r6ur",
  brandName: "Adorro",
  imageUrl:
    "https://cdn.faire.com/fastly/b07c0dd31416ecc41c154b17e1d305ec18c43010042bfd22d476dabc1c42c007.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e719b102d0315b06cd8462246e672f9c3ed364b8714d82062e55611fb7b1b2d6.jpeg",
    "https://cdn.faire.com/fastly/48da445fbb689f77fad6494041861ecf1d545cf2efc6e424b3f20f089408811e.jpeg",
    "https://cdn.faire.com/fastly/138fd720056100e06658a45c11604619c432a42f724c249cb38c58a94d63b98a.jpeg",
    "https://cdn.faire.com/fastly/a24231663a7ee93e6b9af473394febacbabaaf8fda84b67fa60d25575a8af0eb.jpeg",
    "https://cdn.faire.com/fastly/fec2c932482d1fd439adc3779d17392cfa225e624cb61c40e029d36b9f6281c2.jpeg",
    "https://cdn.faire.com/fastly/9b52faa79d3cd2d9d1932b91a4c77a2431ac744e7d41f858212a009d7f0104ee.jpeg",
    "https://cdn.faire.com/fastly/bab7c25ba533057f59ed118d11f5eccd744a41a7fe3259292e743f66b2131612.jpeg",
    "https://cdn.faire.com/fastly/51756284ac1f8494774863704237ded8a66fa646ccbbba2427a76a901a776c2a.jpeg",
    "https://cdn.faire.com/fastly/25378cf9704c16dbe5e6f0a60ed4f2088e74d34f37f3faec904d85a7f5fbc7e1.jpeg",
    "https://cdn.faire.com/fastly/ca9d44af2ede47e514f17ff1157b9e6602eaa0a2bcef937c8ddafda6212f00a4.jpeg",
    "https://cdn.faire.com/fastly/d76af911de98cd49cfe31ab10d5a0104b7a9592b51e02c0c52e16c7576ed9638.jpeg",
    "https://cdn.faire.com/fastly/cf1c444ecae8669cdb66e5746cf72955411599f54e4da632523edf75dde6a42c.jpeg",
    "https://cdn.faire.com/fastly/ba6f79c7130de71a64a0b7e2438182c89606707606afbca7e5204d4c75771648.jpeg",
    "https://cdn.faire.com/fastly/7c8b91911cf7eb7b84a467167082181a4b94128c851d11abdbd3a567c58c78f9.jpeg",
    "https://cdn.faire.com/fastly/860469fbd40eb006a39066aa70e9c8dd1295479564a967ceabd088eafe8652ad.jpeg",
    "https://cdn.faire.com/fastly/bf6dfa215e92acf9524e0b030d93ef974f06f7282cd259b8f36a3d931fcff758.jpeg",
    "https://cdn.faire.com/fastly/516c9260467fc29e5ced8fae4175a417b8c92ea684ebadb756ab9eb847b5be30.jpeg",
  ],
  priceDollars: 15,
  description:
    'Oblong Plaid Multi Color Brushed Fleece Scarves with tassel \nSuper soft and super fuzzy in vibrant multi color plaids, this brushed fleece scarf is like a hug you can wear. Features tassels. \n\nMaterial: 100% Acrylic\nWeight: 10 ounces \nsize: 13.75" W x 75"L (without tassel) \n\n\n',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:54.554Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
